export function closeAlert(evt, target) {
    if (!target) {
        if (!(evt.target instanceof Element))
            return;
        const t = evt.target.closest('.alert');
        if (!t || !(t instanceof HTMLElement))
            return;
        target = t;
    }
    else if (typeof target === 'string') {
        const t = document.getElementById(target);
        if (!t)
            return;
        target = t;
    }
    target.classList.add('hidden');
}
